import { z } from "zod";

export const resetPasswordSchema = z
  .object({
    newPassword: z
      .string()
      .min(6, "Lütfen en az 6 karakterli bir şifre giriniz."),
    newPasswordConfirm: z
      .string()
      .min(6, "Lütfen en az 6 karakterli bir şifre giriniz."),
    email: z.string(),
    code: z.string(),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirm, {
    message: "Şifreler uyuşmuyor.",
    path: ["newPasswordConfirm"],
  });

export type resetPasswordFormData = z.infer<typeof resetPasswordSchema>;

export type ResetPasswordDTO = Omit<
  resetPasswordFormData,
  "newPasswordConfirm"
>;
